import { render, staticRenderFns } from "./FormsMenuPage.vue?vue&type=template&id=052b7022&scoped=true&"
import script from "./FormsMenuPage.vue?vue&type=script&lang=js&"
export * from "./FormsMenuPage.vue?vue&type=script&lang=js&"
import style0 from "./FormsMenuPage.vue?vue&type=style&index=0&id=052b7022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b7022",
  null
  
)

export default component.exports